import {ApigwResponse} from '@shared/helpers/api'
import {isObject} from '@shared/helpers/lang'

import {OrderSheetPageSetType} from '@web/core/constants'

/** 객체에 props에 명시된 모든 프로퍼티가 있는지 확인 */
const hasEveryOwnProperty = <A extends object>(obj: object, props: (keyof A)[]): obj is A =>
    props.every((prop) => Object.prototype.hasOwnProperty.call(obj, prop))

/** app별로 지정된 api route path 하위의 universal url리턴 */
export const getCommonBaseUrl = () => {
    return `${process.env['REACT_APP_API_BASE_PATH'] || process.env['NEXT_PUBLIC_API_BASE_PATH']}/universal`
}

export const getBaseUrl = (_?: Maybe<OrderSheetPageSetType>) => {
    return '/orderApi'
}

/** BFF 를 통해서 내려오는 API 에러 */
export interface ApiGWError<T> {
    code: string
    message: string
    result?: T
}

/** BFF API Response */
export const getAPIResponse = <T>(
    result: T,
    code: ApigwResponseType = ApigwResponse.SUCCESS,
    message = '성공',
): ApigwResponseBase<T> => {
    return {
        code,
        message,
        result,
    }
}

/** BFF API 에러인지 여부 */
export const isBFFApiError = <T>(arg: unknown): arg is ApiGWError<T> =>
    isObject(arg) && hasEveryOwnProperty(arg, ['code', 'message', 'result'])
